module.exports = __webpack_public_path__ + "static/boy-golden-headshot-2023-8a910bdb052cb31479bd750b11aab1d3.jpg";